import { Outlet } from 'react-router';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

export default function ShopLayout() {
  return (
    <Grid container>
      <Grid size={12}>
        <Box sx={{ py: 2 }} />
      </Grid>
      <Outlet />
    </Grid>
  );
}
